import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { enableRipple } from '@syncfusion/ej2-base';
enableRipple(true);
/**
 * RTE overview Sample
 */
import { RichTextEditor, Toolbar, Link, Image,Count, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-richtexteditor';
import { WebServiceService } from './web-service.service';
import { AuthService } from './shared/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { BooleanFilterComponent } from '@progress/kendo-angular-grid/dist/es/filtering/boolean-filter.component';
RichTextEditor.Inject(Toolbar, Link, Image,Count, HtmlEditor, QuickToolbar);
// import { BnNgIdleService } from 'bn-ng-idle';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
   
})
export class AppComponent {
    sessionmenu: any;
    mainmenu: any;
    submenu: any;
    googletranslator:boolean = true;
  // menuItems = [];
  mainmenuitems: any;
  // totelmenuItems: any = [];
    constructor(public authService:AuthService,private router:Router,public service:WebServiceService){  
       
          let defaultRTE: RichTextEditor = new RichTextEditor({
    
        toolbarSettings: {
            items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                'Outdent', 'Indent', '|',
                'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
                'SourceCode', '|', 'Undo', 'Redo']
        },
        showCharCount: true
        
    });
    defaultRTE.appendTo('#defaultRTE');}
   
    menuactive(){
      if(this.router.url=="/login?returnUrl=%2F" || this.router.url=="login"){
        this.googletranslator = false;
        console.log(this.router.url,"falsyy")
              }else{
                this.googletranslator = true;
              }
              if(sessionStorage.getItem("currentUser")){
      this.service.httpGet("userMenusProgram?userId="+JSON.parse(sessionStorage.getItem("currentUser")).user_id)
      .subscribe((data:any) =>{ 
        let menuItems = []=  data.data;
        let totelmenuItems =  menuItems.push("/home","/change-pwd","/termscondition","/privacypolicy","/cookiepolicy","/contact-details","/itnery","/payment-redirect","/payment-failed",
        "/attraction-booking","/ticket-inventory");
        
        let activemenu = this.router.url.split('?')[0];
          if(menuItems.indexOf(activemenu) >=0){
        } else{
          this.authService.logout();
          this.router.navigate(['login']); 
        }
   });
  }
    }

  ngOnInit() {
    this.router.events.subscribe((event) => {
     if (!(event instanceof NavigationEnd)) {
         return;
     }
     window.scrollTo(0, 0)
     });
   }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts